import { render, staticRenderFns } from "./TBmConfigList.vue?vue&type=template&id=76b20025&scoped=true&"
import script from "./TBmConfigList.vue?vue&type=script&lang=js&"
export * from "./TBmConfigList.vue?vue&type=script&lang=js&"
import style0 from "./TBmConfigList.vue?vue&type=style&index=0&id=76b20025&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b20025",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b20025')) {
      api.createRecord('76b20025', component.options)
    } else {
      api.reload('76b20025', component.options)
    }
    module.hot.accept("./TBmConfigList.vue?vue&type=template&id=76b20025&scoped=true&", function () {
      api.rerender('76b20025', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basedata/TBmConfigList.vue"
export default component.exports